import { isNotNil } from "client/Misc/utils";
import {
	RefObject,
	useCallback,
	useEffect,
	useRef
} from "react";

export function useDelayedEvent(callback: () => void, delay: number): [
	trigger: () => void,
	cancel: () => void
] {
	const timeoutRef: RefObject<SetTimeoutHandle | undefined> = useRef<SetTimeoutHandle>(undefined);

	const trigger = useCallback(
		(): void => {
			if (isNotNil(timeoutRef.current)) {
				return;
			}

			timeoutRef.current = setTimeout(
				() => {
					callback();
					timeoutRef.current = undefined;
				},
				delay
			);
		},
		[callback, delay]
	);

	const cancel = useCallback(
		(): void => {
			if (isNotNil(timeoutRef.current)) {
				clearTimeout(timeoutRef.current);
				timeoutRef.current = undefined;
			}
		},
		[]
	);

	useEffect(
		(): EffectWithDestructorResult => {
			return () => cancel();
		},
		[cancel]
	);

	return [trigger, cancel];
}